import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import { isMockMode } from './__dev__/isMockMode';
import { useAuthStore } from './features/auth/store/auth';

async function bootstrap() {
  /** 🔧 TEMPORARY — remove mock mode before merging to main */
  if (isMockMode) {
    const tokenPayload = {
      accessToken: crypto.randomUUID(),
      expiresIn: 86400,
      tokenType: 'Bearer',
      scope: ['openid'],
    };

    // loginCompleted persists to storage internally — no need for a separate call
    useAuthStore.getState().loginCompleted(tokenPayload);

    // eslint-disable-next-line no-console
    console.log(
      '%c🔧 MOCK API ENABLED — service-level mocks, no real backend',
      'color: #faad14; font-weight: bold; font-size: 14px;'
    );
  }

  createRoot(document.getElementById('root')!).render(
    <StrictMode>
      <App />
    </StrictMode>
  );
}

bootstrap();
